import i18n from "@/i18n";
import store from "@/store";

/**
 * Correspondance entre une autorité Spring Security et la clé i18n du libellé
 * de rôle affiché à l'utilisateur. L'ordre détermine la priorité : le premier
 * rôle trouvé sur l'utilisateur gagne.
 */
const ROLE_LABEL_KEYS: ReadonlyArray<[string, string]> = [
  ["ROLE_MANAGER", "userPreference.manager"],
  ["ROLE_CDV", "userPreference.salesManager"],
  ["ROLE_SECRETARY", "userPreference.secretary"],
  ["ROLE_ASSISTANT", "userPreference.assistant"],
  ["ROLE_AGENT", "userPreference.agent"],
  ["ROLE_SALES", "userPreference.salesperson"],
  ["ROLE_PREPATEUR", "userPreference.preparer"],
  ["ROLE_AUDITORS", "userPreference.auditor"],
];

/**
 * Libellé traduit du rôle de l'utilisateur connecté.
 *
 * Mutualisé entre le header et la carte de profil : les deux affichent le même
 * intitulé et doivent rester alignés si la liste des rôles évolue.
 *
 * @returns le libellé traduit, ou une chaîne vide si aucun rôle connu.
 */
export function getConnectedUserRoleLabel(): string {
  const authorities = store.getters["authModule/getUserConnected"]?.authorities || [];
  const match = ROLE_LABEL_KEYS.find(([authority]) =>
    authorities.some((el: { authority: string }) => el?.authority === authority)
  );
  return match ? i18n.global.t(match[1]) : "";
}
